import { useMutation } from '@tanstack/react-query';

import { configs } from '@hero/configs';
import { DEFAULT_MERCHANT_NAME } from '@hero/configs/constants';

import { organizationServices } from '../../index';
const merchantCode =
  configs.merchantName === DEFAULT_MERCHANT_NAME ? '1800flowers' : configs.merchantName;
export const useCheckUserExists = () =>
  useMutation(({ email }) => organizationServices.checkUserExistence(email, merchantCode));
